
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import { wechatPayPC, orderDetail } from '@/services/http';
import CountDown from '@/components/countdown/index.vue';
import QRCode from 'qrcodejs2';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    CountDown
  }
})
export default class extends Vue {
  // 支付类型，1支付宝支付,2微信支付,
  radio: number = 1

  totalPrice: string = ''

  paytime: number = 0 // 订单支付倒计时时间

  surplus: number = 0

  created() {
    this.wechatPayPC();
    window.setInterval(() => {
      setTimeout(() => {
        this.getPayTime();
      }, 0);
    }, 1000);
  }

  private async wechatPayPC() {
    const res: any = await wechatPayPC({
      orderNo: this.$route.query.id,
      equip: '',
      version: ''
    });
    if (res.data.code === 100) {
      // eslint-disable-next-line no-unused-vars
      const qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: res.data.data.code_url,
        width: 320,
        height: 320,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
    }
  }

  //  获取支付倒计时时间
  private async getPayTime() {
    const anchor = readCookie('anchor');
    const res: any = await orderDetail({
      orderNo: this.$route.query.id,
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : ''
    });
    if (res.data.code === 100) {
      this.paytime = Date.now() + Number(res.data.data.surplus) * 1000;
      this.surplus = +res.data.data.surplus;
      this.totalPrice = res.data.data.totalAmount;
      if (res.data.data.orderStatus === 1) {
        window.location.href = `${process.env.VUE_APP_BASE_API}/payment-success?id=${this.$route.query.id}`;
      }
    }
  }

  goBack() {
    this.$router.back();
  }
}
